<template>
	<div class="md-layout">
		<div class="md-layout-item md-size-30">
			<div class="md-multiselect">
				<multiselect v-model="selectedOption" placeholder="Type de dispositifs *"
					label="name" track-by="name" :options="isEditRow ? device.current_device_type.device_report_type.device_types : deviceTypes" :option-height="104"
					return="id" :show-labels="false">
					<template slot="singleLabel" slot-scope="props">
						<img class="option__image" :src="props.option.icon" alt="picto">
						<span class="option__desc">
						<span class="option__title">{{ props.option.name }}</span>
					</span>
					</template>
					<template slot="option" slot-scope="props">
						<img class="option__image" :src="props.option.icon" alt="picto">
						<div class="option__desc">
							<span class="option__title">{{ props.option.name }}</span>
						</div>
					</template>
					<template slot="noOptions">
						La liste est vide
					</template>
					<template slot="noResult">
						Aucun élement correspondant
					</template>
				</multiselect>
				<validation-error :errors="apiValidationErrors.idDeviceType" />
			</div>
		</div>
		<div class="md-layout-item md-size-15">
			<md-field class="md-invalid">
				<label>Numéro</label>
				<md-input v-model="device.number" required type="number"></md-input>
				<validation-error :errors="apiValidationErrors.number" />
			</md-field>
		</div>
		<div class="md-layout-item md-size-40">
			<md-field class="md-invalid">
				<label>Localisation</label>
				<md-input v-model="device.location" required type="text"></md-input>
				<validation-error :errors="apiValidationErrors.location" />
			</md-field>
		</div>
		<div class="md-layout-item md-size-10">
			<div class="flex h-full items-center">
				<div v-if="device.idRow === 'newDevice-0'">
					<md-button class="md-icon-button md-raised md-info"
						@click="duplicateDevice(device)">
						<i class="md-icon fa fa-plus"/>
					</md-button>
					<md-tooltip md-direction="top">Dupliquer</md-tooltip>
				</div>
				<div v-else>
					<md-button class="md-icon-button md-raised md-danger"
							   @click="deleteDevice(device)">
						<i class="md-icon fa" :class="device.device_types ? 'fa-trash' : 'fa-minus'"/>
					</md-button>
					<md-tooltip md-direction="top">Supprimer</md-tooltip>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
	name: "DeviceRow",
	components: {
		ValidationError
	},
	mixins: [formMixin],
	props: {
		device: Object,
		deviceTypes: Array,
        idRow: String,
		errors: Array,
        isEditRow: Boolean
	},
	data() {
		return {
			options: [],
			selectedOption: null
		}
	},
	methods: {
		duplicateDevice(device) {
			this.$emit('duplicate', device)
		},
		deleteDevice(device) {
			this.$emit('delete', device)
		},
        checkRow() {
            if(this.idRow) {
                this.device.idRow = this.idRow
            }
            if(this.device.idDeviceType === null) {
                this.selectedOption = null
            }
            const deviceTypes = this.isEditRow ? this.device.current_device_type.device_report_type.device_types : this.deviceTypes
            if(this.device.idDeviceType) {
                this.selectedOption = deviceTypes.find(deviceType => deviceType.id === this.device.idDeviceType)
            } else if(this.device.current_device_type) {
                this.selectedOption = deviceTypes.find(deviceType => deviceType.id === this.device.current_device_type.id)
            }
        }
	},
	mounted() {
        this.checkRow()
	},
    updated() {
        this.checkRow()
    },
    watch: {
		selectedOption(value) {
            if(value) {
                this.device.idDeviceType = value.id
            }
		},
		errors: function(newVal, oldVal) {
			this.resetApiValidation()
			if(newVal !== oldVal) {
				let errors = []
				newVal.map(error => {
					let parts = error.source.pointer.split('.')
					let partsDevice = this.device.idRow.split('-')
					if (parseInt(parts[1]) === parseInt(partsDevice[1])) {
						errors.push({
							source: { pointer: '/data/attributes/' + parts[2] },
							detail: error.detail
						})
					}
				})
				this.setApiValidation(errors)
			}
		}
	}
}
</script>

<style scoped lang="scss">
.md-layout:not(:first-child) {
    margin-top: .5rem;
}
</style>
